import React from "react";
import clsx from "clsx";
import { QQLink, QQSection } from "common/components";
import { QuoteResultsDownloadUri } from "./constants";
import { trackCreateQuote, trackDownloadQuote } from "common/tagManagerService";
import { downloadFileWithSessionSafely, useEgerdauToken } from "common/services";

interface SummaryLinkSectionProps {
  uid: string;
}

export const SummaryLinkSection: React.FC<SummaryLinkSectionProps> = ({ uid }) => {
  const token = useEgerdauToken();
  const handleDownloadClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    trackDownloadQuote();
    downloadFileWithSessionSafely(QuoteResultsDownloadUri(uid), token, "Quote results download");
  };

  return (
    <QQSection blue className={clsx("d-flex justify-content-end align-items-center py-14 px-20")}>
      <span className="d-inline-block me-32">
        <QQLink onClick={() => trackCreateQuote()} link href="/" className="font-size-14 fw-bold">
          Create Another Quote
        </QQLink>
      </span>
      <span>
        <QQLink onClick={handleDownloadClick} button href="#" className="font-size-14">
          Download Quote
        </QQLink>
      </span>
    </QQSection>
  );
};
